import React from "react";
import WsrvImage from "../utils/WsrvImage";

export default function D01({ photoItem }) {
  return (
    <div>
      {/* {JSON.stringify(photoItem)} */}
      <div className="container  m-auto pt-[10px] pb-[1rem] px-[1rem] sm:px-[2rem] lg:px-[3rem]">
        <div className="grid grid-rows">
          {photoItem?.advanceData?.data?.length && (
            <div className="grid grid-cols-12 gap-[1rem]">
              {photoItem.advanceData.data.map((item, index) => (
                <div className="col-span-12  sm:col-span-6  md:col-span-6  lg:col-span-3 xl:col-span-3 " key={index}>
                  {item?.url && (
                    <div className="w-full h-full">
                      <WsrvImage
                        src={item.url}
                        alt={item.alt || `Photo ${index + 1}`}
                        preset="card"
                        width={400}
                        height={300}
                        sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 400px"
                        className="w-full h-full object-cover rounded-md"
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
